import { CircleAlert, Construction, LockKeyhole } from 'lucide-react'

import { Card } from '../Card/Card'
import styles from './StatePanel.module.css'

type StatePanelProps = {
  kind?: 'empty' | 'error' | 'forbidden'
  title: string
  description: string
}

export function StatePanel({
  kind = 'empty',
  title,
  description,
}: StatePanelProps) {
  const Icon =
    kind === 'error'
      ? CircleAlert
      : kind === 'forbidden'
        ? LockKeyhole
        : Construction
  return (
    <Card className={styles.panel}>
      <span className={styles.icon} aria-hidden="true">
        <Icon size={24} />
      </span>
      <h2>{title}</h2>
      <p>{description}</p>
    </Card>
  )
}
